import React from 'react';
import Button from './../../components/button/button';
import { navigationContext } from '../../context';
import { getHelioDatas } from '../../utils/getHelioDatas';


const ViewSelector = ({ showViewButtons, displayViewName, handleButtonClick, handleSelect, selectedView,helioDatas }) => {

  return (
    <div id="viewSelector" className="buttonContainerView">
      <div className="buttonContainerMainView">
        <Button
          customClass={displayViewName ? 'btnPdv' : 'btnPdv'}
          onClick={() => handleButtonClick('view')}
          text={displayViewName ? displayViewName : 'Choisir le point de vue'}
          // icon={'picto-view'}
        />
      </div>
      {showViewButtons && (
        <div className='buttonContainerDisplayView'>
          {helioDatas.cameras.map((view) => (
            <Button
              key={view.id}
              onClick={() => handleSelect(view, 'view')}
              text={view.displayName}
              // customClass={view.id === selectedView ? 'test' : 'test'}
              customClass={view.id === selectedView ? 'pdvGrayed' : 'pdvNormal'}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ViewSelector;